<template>
  <v-col cols="12">
    <v-slide-group v-model="slide" show-arrows>
      <v-slide-item
        v-for="(item, i) in sortedActionItems"
        class="my-4 mx-3"
        :key="i"
      >
        <action-item-avatar :actionItem="item"></action-item-avatar>
      </v-slide-item>
    </v-slide-group>
  </v-col>
</template>

<script>
import ActionItemAvatar from "@/components/checkin/ActionItemAvatar";
export default {
  name: "CoreCardActionItems",
  components: { ActionItemAvatar },
  props: {
    coreCard: { type: Object }
  },
  data: () => ({
    slide: null
  }),
  computed: {
    sortedActionItems() {
      return this._.sortBy(this.coreCard.actionItems, function(o) {
        if (o.completed == true) {
          return 1;
        } else if (o.completed == null) {
          return 2;
        }
        return 3;
      });
    }
  }
};
</script>
